<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">Summary of DP/Prepaid AP Invoice
        <div class="card-header-actions">
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label style="width:170px !important;">DP/Prepaid Inv. Account</label></b-input-group-prepend>
              <b-form-select v-model="model.account" :plain="true" :options="accounts" style="width:30% !important;"></b-form-select>
              <b-input-group-prepend><span class="input-group-text">GL Acc.#</span></b-input-group-prepend>
              <b-form-input v-model="model.kodeacc" readonly placeholder="GL Account Code"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="4">
            <b-input-group >
              <b-input-group-prepend><label >As Of Date</label></b-input-group-prepend>
              <b-form-input v-model="model.tgl2" type="date"></b-form-input>
              <b-input-group-append><b-button class="ml-3 btn btn-success" @click="getData()" > <i class="fa fa-play"></i> Process</b-button></b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body>
          <template v-slot:header v-if="(filterShow=='Hide')">          
            <b-row >
                <b-col lg="3">
                  <b-input-group size="sm" class="mt-1">
                    <b-input-group-prepend><span class="pt-1 mr-1" >FILTER</span></b-input-group-prepend>
                    <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                        ></b-form-input>
                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                    </b-input-group-append>
                    </b-input-group>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>

                </b-col> 
                <b-col lg="9">
                  <b-form-group
                    label="FILTER ON :"
                    label-cols-sm="1"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="pbb_acc">DP/Prepaid Inv. Account</b-form-checkbox>
                      <b-form-checkbox value="paymno">Payment No.</b-form-checkbox>
                      <b-form-checkbox value="vendorinfo">Customer </b-form-checkbox>
                      <b-form-checkbox value="uraian">Description</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>                
                </b-col>                 
            </b-row>
        </template>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblLcy.fields"
                :current-page="tblLcy.page"
                :per-page="tblLcy.limit"
                :sort-by.sync="tblLcy.sortBy"
                :sort-desc.sync="tblLcy.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
              <template v-slot:cell(invdate)="data">
                  {{ data.item.invdate | moment("DD-MMM-YYYY") }}
                  <!-- <span v-if="(data.item.tanggal)">{{ data.item.tanggal | moment("DD-MMM-YYYY") }}</span> -->
              </template>
                <template v-slot:cell(nilaiori)="data">
                      {{ data.item.nilaiori | numFormat }}
                </template>
                <template v-slot:cell(dpinv_ost)="data">
                      {{ data.item.dpinv_ost | numFormat }}
                </template>
                <template v-slot:cell(dpinv_ostLcy)="data">
                      {{ data.item.dpinv_ostLcy | numFormat }}
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col lg="9">
                    <b-row >
                      <b-col cols="2">            
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-2">
                          <b> {{ filterShow }}</b>  Filter
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="10">
                        <div style="display: flex;margin:0;padding:0;">
                            <div style="margin:0;padding:5px;width:500px; text-align:right;">
                                Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                                to <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span> <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                                of {{tblLcy.total}} entries,   <span class="mr-1">limit per page :</span> 
                                <select  v-model="tblLcy.limit"  style="width:60px;">
                                  <option>10</option>
                                  <option>15</option>
                                  <option>20</option>                            
                                  <option>25</option>
                                  <option>30</option>                            
                                  <option>40</option>                            
                                  <option>50</option>                            
                                  <option>60</option>                            
                                  <option>70</option>                            
                                  <option>80</option>                            
                                  <option>90</option>                            
                                </select>
                            </div>
                            <div>
                                <b-pagination  class="ml-1" 
                                  align="left"
                                  :total-rows="tblLcy.total"
                                  :per-page="tblLcy.limit"
                                  v-model="tblLcy.page"
                                ></b-pagination>
                            </div>
                        </div>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col lg="3">
                        <b-input-group >
                            <b-input-group-prepend><label >Total Balance (LCY)</label></b-input-group-prepend>
                            <my-number class="form-control text-right mr-5" v-model="outstandLcy" :precision="2" disabled></my-number>
                        </b-input-group>
                </b-col>
            </b-row>
      </b-card>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
 
</style>

<script>
import moment from 'moment';
import myNumber from "../../components/my-number";
import apreport from "../../apis/apreport";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        tgl2: { required },
    },
  }, 
  data() {
    return {
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model: {tabIndex:0, account:'',tgl1:'',tgl2:''},
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      outstandLcy:0,
      rptLines : [],
      subtotal : {},
      filterShow:'Show',
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "dp_acc",
            label: "DP Acc.",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "nomorbank",
            thStyle: "width:100px",
            label: "Payment No.",
            sortable: true
          },
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "AP Number",
            sortable: true
          },
          {
            key: "invoice",
            thStyle: "width:100px",
            label: "Invoice Number",
            sortable: true
          },
          {
            key: "invdate",
            thStyle: "width:70px",
            label: "Invoice Date",
            sortable: true
          },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            sortable: true
          },
          {
            key: "matauang",
            label: "$,¥",
            thStyle: "width:50px",
            sortable: true
          },
          {
            key: "nilaiori",
            label: "DP Amount",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "dpinv_ost",
            label: "DP Balance",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "dpinv_ostLcy",
            label: "DP Balance (LCY)",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging",
            label: "Age(days)",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "po",
            thStyle: "width:100px",
            label: "PO Number",
            sortable: true
          },
        ]
      },
      filter: null,
      filterOn: [],   



    };
  },
  components: {Loading, myNumber},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    account() {
        return this.model.account;
    },
  },
  watch:{
    account: function(newval) {
      const obj=this.accounts.find(d => d.value === newval);
        this.model.namaacc=obj.text || '';
        this.model.kodeacc=obj.kodeacc;
        // console.log(`${this.model.account} | ${this.model.namaacc}`);
    },
    // showSummary : function(newval) {
    //     if (newval===true) {
    //         if (this.model.tabIndex === 0) {
    //           this.model.view = 'Summary in Original Currency';
    //         } else {
    //           this.model.view = 'Summary in Local Currency';
    //         }
    //     } else {
    //       this.model.view= 'Detail Invoice Outstanding';
    //     }        
    // },   
  },  
  created: async function(){
      const accList = await apreport.groupdp();
      this.accounts = accList.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.model.tgl1=this.$store.state.user.tglaktif;
        this.model.tgl2=tgl2.format('YYYY-MM-DD');

        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          this.tblLcy.fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }        
  },  
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
      // this.totalBank_in = filteredItems.reduce((a, b) => a + b.bank_in, 0);
      // this.totalBank_out = filteredItems.reduce((a, b) => a + b.bank_out, 0);
    },     
    clearFilter() {
          this.filterOn= []   
          this.filter= '';   
    } ,
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.isLoading=true;
        const result = await apreport.dpinvsmry(this.model);
        this.rptLines =  result[0];
        this.subtotal = result[1][0];
        // console.log('subtotal: ',this.subtotal);     
        this.tblLcy.total = this.rptLines.length;       
        // for (let index = 0; index < this.tblLcy.total; index++) {
        //   this.rptLines[index].dpinv_ostLcy = this.rptLines[index].dpinv_ost*this.rptLines[index].kursPPN;
        // } 
        this.rptLines.forEach(element => {
          element.dpinv_ostLcy = element.dpinv_ost*element.kursPPN;
        });
        this.outstandLcy = this.rptLines.reduce((a, b) => a + (b.dpinv_ostLcy ||0), 0);
        this.isLoading=false;      
       }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await apreport.dpinvsmryexport(this.model);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR',10000);
            }
        }
      }
    },  
    printjv: async function()
    {
      if (this.model) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await apreport.printjv(this.model);
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    close(){
          router.push("/receivable/home");
    }
  }
};
</script>
